import {
  Box,
  Button,
  DialogBackdrop,
  DialogBody,
  DialogContent,
  DialogPositioner,
  DialogRoot,
  Flex,
  Image,
} from '@chakra-ui/react';

type Props = {
  url: string | null;
  onClose: () => void;
  onDownload: () => void;
};

export function ImageLightbox({ url, onClose, onDownload }: Props) {
  return (
    <DialogRoot
      open={!!url}
      onOpenChange={({ open }) => {
        if (!open) onClose();
      }}
    >
      <DialogBackdrop bg="blackAlpha.800" />
      <DialogPositioner display="flex" alignItems="center" justifyContent="center" p={4}>
        <DialogContent bg="transparent" boxShadow="none" w="100%" maxW="min(640px, 100vw)" maxH="80vh">
          <DialogBody display="flex" alignItems="center" justifyContent="center" p={0} onClick={onClose}>
            {url && (
              <Box position="relative" display="inline-block" onClick={(e) => e.stopPropagation()}>
                <Image
                  src={url}
                  alt="Full size image"
                  maxW="100%"
                  maxH="70vh"
                  objectFit="contain"
                  borderRadius="lg"
                />
                <Flex position="absolute" top={2} right={2} alignItems="center" gap={2}>
                  <Button
                    size="sm"
                    colorPalette="blue"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDownload();
                    }}
                    borderRadius="full"
                    w={9}
                    h={9}
                    minW={9}
                    aria-label="Save photo"
                    bg="blackAlpha.600"
                    _hover={{ bg: 'blackAlpha.700' }}
                    color="white"
                  >
                    <Box as="span" display="flex" alignItems="center" justifyContent="center">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 5V15M8 11L12 15L16 11M6 19H18"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Box>
                  </Button>
                  <Button
                    size="sm"
                    borderRadius="full"
                    w={9}
                    h={9}
                    minW={9}
                    aria-label="Close photo"
                    bg="blackAlpha.600"
                    _hover={{ bg: 'blackAlpha.700' }}
                    color="white"
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose();
                    }}
                  >
                    <Box as="span" display="flex" alignItems="center" justifyContent="center">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </Box>
                  </Button>
                </Flex>
              </Box>
            )}
          </DialogBody>
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
}
